import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25901b77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[40px] tw-self-stretch tw-p-[40px] tw-bg-[#FFFFFF]" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_5 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-justify-between md:tw-items-start tw-gap-[20px] tw-self-stretch tw-rounded-[4px] tw-p-[10px] md:tw-p-[25px] main" }
const _hoisted_7 = { class: "tw-w-full tw-flex md:tw-items-center tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row" }
const _hoisted_8 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px]" }
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row" }
const _hoisted_11 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]" }
const _hoisted_12 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-4 tw-flex-col md:tw-flex-row" }
const _hoisted_15 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-medium tw-leading-[15px] tw-min-w-[260px] tw-pt-[21px]" }
const _hoisted_16 = { class: "tw-flex tw-flex-col tw-w-full tw-max-w-[100%] md:tw-max-w-[630px] tw-relative tw-z-10" }
const _hoisted_17 = { class: "tw-flex tw-flex-row tw-justify-end tw-items-center tw-w-full" }

import { ref, watch, computed, onMounted, PropType } from "vue";
import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { showSuccessToast } from "@/services/apiRoutes";
import ButtonLoading from "../common/buttonLoading.vue";
import DatePickInput from "../common/datePickInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'updateAssessmentDetailModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  checklistAssessmentData: {
    type: Object as PropType<IAssessmentDetail>,
    required: true,
  },
},
  emits: ["update:show", "resetModalHistory"],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const name = ref(props.checklistAssessmentData.checklistName);
const isLoading = ref(false);
const description: any = ref(
  props.checklistAssessmentData.checklistDescription,
);
const reportingDate = ref(props.checklistAssessmentData.checklistDateReporting);
const autoTextarea: any = ref(null);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

onMounted(() => {
  autoResize();
});



const handleClose = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const handleCloseModal = () => {
  if (
    name.value !== props.checklistAssessmentData.checklistName ||
    description.value !== props.checklistAssessmentData.checklistDescription ||
    reportingDate.value !== props.checklistAssessmentData.checklistDateReporting
  )
    return;
  showRef.value = false;
  emit("update:show", showRef.value);
};

const updateAssessment = async () => {
  isLoading.value = true;
  const res = await store.dispatch("Assessment/updateChecklistRename", {
    checklistId: props.checklistAssessmentData.checklistId,
    params: {
      checklistName: name.value,
      checklistDescription: description.value,
      checklistReportingDate: reportingDate.value,
    },
  });
  if (res) {
    showSuccessToast(
      getComponentUiText(
        "app-assess-assessment-modal-update-description-success-1",
      ),
    );
    handleClose();
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] assessment-modal tw-max-w-[1040px]",
    visible: _unref(showRef),
    "border-radius": "4px",
    "overflow-y-scroll": false,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header`),
        title: 
        _unref(getComponentUiText)(
          'app-component-assessment-update-assessment-detail-modal-title-1',
        )
      ,
        onClose: handleClose
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-update-assessment-detail-modal-details-1",
            )), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-update-assessment-detail-modal-description-1",
            )), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-update-assessment-detail-modal-assessment-name-1",
                )), 1),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_BFormInput, {
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  "data-cy": "update-assessment-detail-assessment-name",
                  type: "text",
                  placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-create-assessment-modal-field-placeholder-name-1',
                  )
                ,
                  class: _normalizeClass([`tw-border tw-text-[#231F20] tw-text-[15px] tw-h-[66px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF]`, "autoFocus"])
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-update-assessment-detail-modal-assessment-description-1",
                )), 1),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("textarea", {
                  ref_key: "autoTextarea",
                  ref: autoTextarea,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
                  "data-cy": "update-assessment-detail-assessment-description",
                  placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-create-assessment-modal-field-placeholder-description-1',
                  )
                ,
                  style: `outline-color : #EFF0F1; overflow: auto; resize: none`,
                  class: "auto-expand tw-max-h-[130px] tw-min-h-[130px] tw-text-[15px] tw-font-normal tw-leading-none tw-px-5 tw-pt-[17.5px] tw-pb-[17px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]",
                  onInput: autoResize
                }, null, 40, _hoisted_13), [
                  [_vModelText, description.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessment-update-assessment-detail-modal-reporting-date-1",
                )), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(DatePickInput, {
                  modelValue: reportingDate.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((reportingDate).value = $event)),
                    _cache[3] || (_cache[3] = 
                  (value) => (value ? (reportingDate.value = value) : '')
                )
                  ],
                  placeholder: 
                  _unref(getComponentUiText)(
                    'app-component-assessment-modal-complete-assesment-placeholder-report-date-1',
                  )
                ,
                  disabled: false,
                  "class-name": `tw-w-full !tw-bg-[#FFF] !tw-border tw-text-[#231F20] !tw-text-[15px]`,
                  "data-cy-id": "modal-complete-assessment-reporting-date",
                  focus: true,
                  "custom-input-class": `tw-flex tw-flex-1`
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_b_button, {
            style: {"line-height":"100%","border":"2px solid","height":"39px"},
            variant: "primary",
            class: "tw-w-fit tw-mr-[15px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
            type: "submit",
            onClick: handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
            )), 1)
            ]),
            _: 1
          }),
          _createVNode(ButtonLoading, {
            title: 
            _unref(getComponentUiText)(
              'app-assessment-modal-bulk-answer-question-button-text-1',
            )
          ,
            "is-loading": isLoading.value,
            onClickAction: updateAssessment
          }, null, 8, ["title", "is-loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})